import React, { Component } from 'react'
import Cart from './Cart'
import { connect } from 'react-redux'
import { updatePageLogs, checktime, catchJSException } from '../../../service/logService';
import { Utils } from '../../../util/utils';
import {mvaNavigationPattern } from '../../../constants/actionType';
class CartProduct extends Component {

    componentWillMount(){
        checktime(this.callCheckTime('WillMount'));
        this.processPageAfterVisitID()
      }
      processPageAfterVisitID = () => {
        try {
            updatePageLogs(this.props.appState, this.props.appState.visitId, false);
            checktime(this.callCheckTime('Mount'));
            // getDTMInit("checkAvaillqInit", { appInfo: this.props.appState, lqInfo: this.props.lqState });
        }
        catch (ex) {
            catchJSException('visitId_Error', this.props.appState.visitId, 'processPageAfterVisitID', ex);
        }
    }
    componentDidMount(){
        if(this.props.appState && this.props.appState.isMvaFlow){
            Utils.showHideNativeTitleBackBtn(this.props.appState.mvaType, this.props.appState.isMVAFiosEqipFlow, mvaNavigationPattern.patternD);

        }
    }
    callCheckTime = ((pagestate) => {
        return {
            page: 'FloatingCart',
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false,
            apiFetched: (pagestate === 'ApiFetched') && Date.now()
        }
    })
    
    render() {
       
    //    let cartProductDetails=this.props.cartProduct.cartProduct.map(cartProductDetails=><Cart  cartProductDetail={cartProductDetails} props={this.props}></Cart>);
        let cart=<Cart  appState = {this.props.appState} cartProductDetail={this.props.cartProduct} props={this.props} pushHistory={this.props.history}></Cart>
        return (
                            this.props.showCart &&

                <div className="w_cart-box" style={{ display: 'block'}}>
                <div className="cart-box_mini-block"></div>
                {/* <div className="cart-box_button" data-cart-close="" onClick={this.props.cartHide}>Close <span  className="vzicon icon-close medium text-grey-2 padding-left-tiny" aria-hidden="true"></span><span className="sr-only" >Close</span></div> */}
                <div className="cart-box_button" data-cart-close="" onKeyPress = {this.props.cartHide} onClick={this.props.cartHide}>            <div id="cartClsBtn" tabIndex="0" role="button" onKeyDown={(e)=>{
                 if(e.key==='Escape'){
                    this.props.cartHide();
                 }}}>
            Close <span  className="vzicon icon-close medium text-grey-2 padding-left-tiny" aria-hidden="true"></span></div></div>
            <div onKeyDown={(e)=>{
              if(e.key==='Escape'){
                this.props.cartHide();
              }
            }}>
              {cart}
            </div>
            </div>
            

        )
    }
}
const mapStateToProps = (state) => {
    return { 
        
        cartProduct : state.cartProductDataVTP,
        appState :state.appVTP
    }
}
export default (connect(
    mapStateToProps
)(CartProduct));
// export default cartProduct
